/**
 * Every visitor-facing string, in one place so a translated bundle can replace
 * it later (ticket §12, Q3).
 *
 * Copy rule (ticket §9): describe what the setting does for the visitor. Never
 * "compliant", "ADA", "WCAG", "lawsuit". "Readable font", not "Dyslexia font":
 * the OpenDyslexic step is named by the font, with no claim about what it does.
 */
export const STRINGS = {
  launcher: 'Accessibility preferences',
  title: 'Accessibility preferences',
  intro: 'Change how this site looks for you. Saved in this browser only.',
  close: 'Close accessibility preferences',

  /** Tiles with steps: the name while off, then one label per step. */
  cycles: {
    textSize: {
      name: 'Text size',
      steps: ['Large text', 'Larger text', 'Largest text'],
    },
    font: { name: 'Readable font', steps: ['Readable font', 'OpenDyslexic'] },
    align: {
      name: 'Text alignment',
      steps: ['Align left', 'Align center', 'Align right'],
    },
    contrast: {
      name: 'Contrast',
      steps: ['Dark contrast', 'Light contrast', 'Invert colors'],
    },
    saturation: {
      name: 'Saturation',
      steps: ['Low saturation', 'High saturation', 'Desaturate'],
    },
  },
  /** Announced when a tile with steps goes back to its default: "Contrast off". */
  off: 'off',

  /** One line of help per tile, shown as its tip and read as its description. */
  help: {
    speech:
      'Reads the page out loud. Point at text to hear it, or click to start there.',
    textSize: 'Makes text bigger. Click again for bigger still.',
    font: 'Switches to an easier font: Atkinson Hyperlegible, then OpenDyslexic.',
    align: 'Lines text up on the left, in the center or on the right.',
    spacing: 'Adds space between lines, letters and words.',
    links: 'Underlines and outlines every link.',
    contrast: 'Dark or light high-contrast colors, or inverts the page.',
    saturation: 'Tones colors down, makes them stronger, or removes them.',
    images: 'Hides pictures so the text stands out.',
    guide: 'A bar that follows your mouse to help you keep your place.',
    cursor: 'Makes the mouse pointer much bigger.',
    motion: 'Stops animations, videos and other moving content.',
  },

  spacing: 'Text spacing',
  links: 'Highlight links',
  guide: 'Reading guide',
  cursor: 'Big cursor',
  motion: 'Pause animations',
  images: 'Hide images',

  // Read aloud. Never "screen reader" (ticket §9): it is not one.
  readAloud: 'Read aloud',
  readHint: 'Point at text to hear it. Click to read from there.',
  readClickToStart: 'Click anywhere on the page to start reading.',
  readPage: 'Read page',
  readSelection: 'Read selection',
  readPause: 'Pause',
  readResume: 'Resume',
  readStop: 'Stop reading',
  readSpeed: 'Speed',
  readClose: 'Turn off read aloud',
  readNoVoice: "This browser doesn't have a voice for this page's language.",
  readImage: 'Image',

  reset: 'Reset all settings',
  resetDone: 'All settings are back to default.',
  statement: 'Accessibility statement',
  statementClose: 'Close accessibility statement',

  // "Powered by [Edlio logo] Accessibility". The logo's alt text is the middle word.
  // The logo links to edlio.com in a new tab; screen readers hear "Edlio (opens in a new tab)".
  poweredBy: 'Powered by',
  brandName: 'Edlio',
  brandProduct: 'Accessibility',
  newTab: '(opens in a new tab)',
};
